class FormRuleFromTool {
    Id: number;
    FormRuleSetId: number;
    DataName: string;
    Operator: string;
    ValueMatch: string;
    Sequence: number;
    Actions: any[];
    Chains: any[];

    constructor(id: number, formRuleSetId: number, dataName: string, operator: string, valueMatch: string, sequence: number) {
        this.Id = id;
        this.FormRuleSetId = formRuleSetId;
        this.DataName = dataName;
        this.Operator = operator;
        this.ValueMatch = valueMatch;
        this.Sequence = sequence;
        this.Actions = [];
        this.Chains = [];
    }
}

export default FormRuleFromTool;